import React, { useEffect } from 'react';
import AppLayout from '../common/layouts/appLayout';
import PublicFooterLayout from './components/publicLayout';
import TermsConditionsContent from './components/termsConditionsContent';
import { useSelector, useDispatch } from 'react-redux';
import { clientsFilteredSearch } from '../services/programClientsSlice';
import { getsiteConfigurationInfo } from '../services/siteConfigurationSlice';

const TermsConditions = ({ isAuthenticatedUser }) => {
  const dispatch = useDispatch();
  const selectedClients = useSelector(
    (state) => state.programsClientsSlice.selectedClient
  );
  const clientPrograms = useSelector(
    (state) => state.programsClientsSlice.programClients
  );
  if (!selectedClients.payload && isAuthenticatedUser) {
    dispatch(clientsFilteredSearch(clientPrograms));
    const programId = clientPrograms[0].programid;
    dispatch(getsiteConfigurationInfo({ programId }));
  }
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {isAuthenticatedUser ? (
        <AppLayout>
          <TermsConditionsContent isAuthenticatedUser={isAuthenticatedUser} />
        </AppLayout>
      ) : (
        <PublicFooterLayout title="Terms and Conditions">
          <TermsConditionsContent isAuthenticatedUser={isAuthenticatedUser} />
        </PublicFooterLayout>
      )}
    </>
  );
};

export default TermsConditions;
